import { render, staticRenderFns } from "./TheaterEmailUpdateContainer.vue?vue&type=template&id=8dbc108e&scoped=true"
import script from "./TheaterEmailUpdateContainer.vue?vue&type=script&lang=js"
export * from "./TheaterEmailUpdateContainer.vue?vue&type=script&lang=js"
import style0 from "./TheaterEmailUpdateContainer.vue?vue&type=style&index=0&id=8dbc108e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbc108e",
  null
  
)

export default component.exports